import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";

// Debounce helper
function debounce(func, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
}

const ProjectDropdown = ({ value, onChange }) => {
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";
  // Fetch options from API
  const fetchOptions = async (inputValue) => {
    try {
      const res = await fetch(
        `${API}/api/GetProjects.ashx?search=${encodeURIComponent(inputValue)}`
      );
      const data = await res.json();
      // must be [{ value, label }]
      return data;
    } catch (error) {
      console.error("Error fetching projects:", error);
      return [];
    }
  };

  // Debounced loader
  const loadOptions = useCallback(
    debounce((inputValue, callback) => {
      fetchOptions(inputValue).then(callback);
    }, 300),
    []
  );

  return (
    <AsyncSelect
      id="developer"
      name="developer"
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      value={value}
      onChange={onChange}
      isClearable
      placeholder="Projects"
      className="bordermobilenone"
      styles={{
        control: (base) => ({ ...base, minHeight: "38px", backgroundColor: "#fff" }),
        singleValue: (base) => ({ ...base, color: "#000" }),
        input: (base) => ({ ...base, color: "#000" }),
        placeholder: (base) => ({ ...base, color: "#6c757d" }),
        menu: (base) => ({ ...base, backgroundColor: "#fff", zIndex: 9999999 }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? "#f8f9fa" : "#fff",
          color: "#000",
        }),
      }}
    />
  );
};

export default ProjectDropdown;
